import { getTestDetail } from "../Auth/UserStore";
import { getCurrentUserId } from "../Auth/UserStore";


function getQuestionIdList(questions) {
  return questions.map(q => q.id);
}

export function getTestData(questions){
    const ownerId = getCurrentUserId();
    const questionIds = getQuestionIdList(questions);
    const testDetail = getTestDetail();
    return {
      owner_id: ownerId,
      questions: questionIds,
      name: testDetail.name,
      details: testDetail.detail
    };
}



export function getRowsofQuestion(questions, testId) {
  const ownerId = getCurrentUserId();
  const rows = [];
  for (const question of questions) {
    for (const item of question.items) {
      rows.push({
        q_id: question.id,
        res: item.res,
        media: item.media,
        ind: item.ind,
        time: question.time ?? null,
        test_id: testId,
        owner_id: ownerId,
      });
    }
  }
  return rows;
}


/**
 * Convert a list of questions into correction objects ready for DB insert.
 * Each correction: { question_id, question, hint }
 */


export function buildCorrections(questions) {
  return questions.map((q) => {
    let questionText = "";

    for (const item of q.items) {
      const isMedia = item.media === "image" || item.media === "video";
      const isMcq = item.res?.mcq;
      const mediaLabel = item.media === "video" ? `Video-${item.ind}` : `Image-${item.ind}`;

      if (isMedia) {
        if (isMcq) {
          questionText += `\nOption-${item.res.mcq}: ${mediaLabel}`;
        } else {
          questionText += `\n${mediaLabel}`;
        }
      } else {
        // Text item
        const text = Array.isArray(item.res?.text)
          ? item.res.text.join(" ").trim()
          : item.res?.text || "";

        if (isMcq) {
          questionText += `\nOption-${item.res.mcq}: ${text}`;
        } else {
          questionText += `\n${text}`;
        }
      }
    }

    return {
      question_id: q.id,
      question: questionText.trim(),
      hint: q.solution?.hint || "",
    };
  });
}

